<template>
  <div id="noble">
    <van-nav-bar
      :title="document_title"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-tabs @click="onClickTabs" v-model="active">
      <van-tab v-for="(l,i) in list" :key="i" :title="l.name">
        <van-col span="24" class="noble_top">
          <img :src="l.shop_icon"
               class="noble_top_img"/>
        </van-col>
        <div class="noble_type">
          <van-col span="24" class="noble_type_name">{{ $t('column.aristocratic_privilege')}}</van-col>

          <van-col span="6" class="noble_genre" v-for="(n,j) in l.noble_type" :key="j">
            <van-col span="24" class="noble_genre_img" @click="noble_instructions(n)">
              <img :src="n.shop_icon" class="noble_genre_type_img" v-if="n.type === '1'"/>
              <img :src="n.noicon" class="noble_genre_type_img" v-else/>
            </van-col>
            <van-col span="24" :class="['noble_genre_name' ,n.type === '1' ? 'noble_genre_color' : '']">{{ n.title }}
            </van-col>
          </van-col>

          <div class="noble_bottom">
            <van-col span="12">
              <van-col span="24" class="noble_bottom_day" v-if="l.noble_recharge">
                <span>{{ l.noble_recharge.money }}</span> {{ virtual_coin }} / {{ l.noble_recharge.day}}
                {{ l.noble_recharge.unit }}
              </van-col>
              <van-col span="24" class="noble_bottom_status" v-if="user.noble_time && user.nobleid === l.id">{{ $t('column.due_date')}} {{
                user.noble_time }}
              </van-col>
            </van-col>
            <van-col span="12">
              <van-col span="20" offset="2" class="noble_bottom_btn" @click="noble_show(l.id)"> {{ user.noble_time &&
                user.nobleid === l.id ? $t('btn.renew') : $t('btn.Opening') }}
              </van-col>
            </van-col>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '68%' }"
    >
      <van-col span="24" class="show_title">{{ money_list.name }}</van-col>
      <van-col span="24" class="show_type">
        <van-col span="8" class="show_type_money" v-for="m in money_list.list" :key="m.id">
          <van-col span="24" :class="['show_type_money_status',show_id === m.id ? 'show_type_money_status_color' : '']"
                   class="show_type_money_status" @click="show_type_btn(m.id)">
            <van-col span="24" class="show_type_money_day">{{ m.day }}</van-col>
            <van-col span="24" class="show_type_money_day_name">{{ m.unit }}</van-col>
            <van-col span="24" class="show_type_money_sum">{{ m.money }}{{ virtual_coin }}</van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="show_information"> {{ $t('column.Remarks_month_30_days')}}</van-col>
      <van-col span="24" class="show_information"> {{ $t('column.Equip_the_nobleman')}}</van-col>
      <van-col span="20" offset="2" class="show_btn" @click="show_btn()"> {{ $t('btn.purchase')}}</van-col>
    </van-popup>
    <van-overlay :show="is_noble_instructions" v-if="instructions.content">
      <div class="noble_instructions_div" @click="is_noble_instructions = false">
        <div class="noble_instructions_div_block">
          <van-col span="4" offset="4" class="noble_instructions_div_block_left_bor"></van-col>
          <van-col span="8" class="noble_instructions_div_block_title">{{ instructions.instructions }}</van-col>
          <van-col span="4" class="noble_instructions_div_block_right_bor"></van-col>
          <van-col span="20" offset="2" class="noble_instructions_img">
            <img :src="instructions.instructions_img"/>
          </van-col>
          <van-col span="20" offset="2" class="noble_instructions_name">{{ instructions.content }}</van-col>
          <div class="noble_instructions_btn">{{ $t('Tips.got_it')}}</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
    import '@/assets/css/style.css'
    import axios from 'axios'
    import Toast from "vant/lib/toast";
    import {Dialog} from "vant";
    export default {
        data() {
            return {
              document_title: '',
                active_top: '',
                list: [],
                user: [],
                money_list: {},
                show_id: '',
                noblie_id: '',
                virtual_coin: '',
                show: false,
                instructions: {},
                is_noble_instructions: false,
                active: 0,
            }
        },
        created: function () {
            this.convert();
            this.virtual_coin = this.$t('other.Company')
            this.document_title = this.$t('title.noble')
        },
        methods: {
            onClickTabs() {
                this.show_id = 0;
            },
            convert() {
                const uid = this.$route.query.uid
                const token = this.$route.query.token
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=noble&act=index", {
                    params: {
                        uid: uid,
                        token: token
                    }
                }).then(res => {
                    console.log(res.data)
                    this.list = res.data.data.list
                    this.user = res.data.data.user_info ? res.data.data.user_info : {}
                    if (res.data.status === 0) {
                        Toast(res.data.error)
                    }
                })
            },
            noble_instructions(n) {
                console.log(n)
                this.instructions = n
                this.is_noble_instructions = true
            },
            show_type_btn(id) {
                this.show_id = id
            },
            noble_show(id) {
                this.noblie_id = id
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=noble&act=select_coin", {
                    params: {
                        id: id
                    }
                }).then(res => {
                    console.log(res.data)
                    this.money_list = res.data
                    if (res.data.status === 1) {
                        this.show = true
                    } else {
                        Toast(res.data.error)
                    }
                })
            },
            show_btn() {
                if (!this.show_id) {
                    Toast.fail(this.$t('Tips.Select_purchase_category'));
                    return false
                }
                let name = this.$t('Tips.is_purchase_noble_members')
                if (this.noblie_id === this.user.nobleid && this.user.noble_time) {
                    name = this.$t('Tips.is_renewal_noble_membership')
                } else if (this.noblie_id !== this.user.nobleid && this.user.noble_time) {
                    name = this.$t('Tips.Empty_former_noble_members')
                }
                Dialog.confirm({
                    title: this.$t('column.buying_aristocrats'),
                    message: name,
                  confirmButtonText: this.$t('btn.confirm'),
                  cancelButtonText: this.$t('btn.cancel'),
                }).then(() => {
                    const uid = this.$route.query.uid
                    const token = this.$route.query.token
                    axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=noble&act=pay", {
                        params: {
                            user_id: uid,
                            token: token,
                            id: this.show_id
                        }
                    }).then(res => {
                        console.log(res.data)
                        Toast(res.data.error)
                        if (res.data.status === 1) {
                            this.convert()
                            this.show = false
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/noble.vue